import FieldsFactory from 'components/form/FieldsFactory'
import {Formik, FormikConsumer, useFormikContext} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import {Pure} from "../../../../components/Pure";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {StepsForm} from "../../../../components/form/StepsForm";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import Toggle from "../../../../components/Toggle";
import {catholicHouseholdFormSchema} from "./catholicHouseholdFormSchema";
import {formatDate, getDateString, parseDayjs} from "../../../../helpers/datetimeHelpers";
import {ChildrenMemberItemInfo, ParentMemberItemInfo, SacramentItem} from "./CatholicHouseholdComponents";
import classNames from 'classnames'
import {GoDotFill} from "react-icons/go";
import {BsChevronDown} from "react-icons/bs";
import {renderIf, renderIfElse, shallowDiff} from "../../../Shared";
import EmptyHolder, {EmptyHolderWithAction} from "../../../../components/EmptyHolder";
import {BrideIconOutlineSvg, GroomIconOutlineSvg} from "../../../../components/Svgs/ParentIconSvg";
import {GiIronCross} from "react-icons/gi";
import {renderEmptyHolderMember} from "../functions/renderEmptyHolderMember";
import {Button, message} from "antd";
import copyToClipboard from "copy-to-clipboard";
import getLinkToDetail, {getAbsoluteLinkToDetail} from "../../../../helpers/getLinkToDetail";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {FiEdit3} from "react-icons/fi";
import {HeaderButton} from "../../../Organization/components/PageHeader";
import {callNativeShare} from "../../../../helpers";
import getTitle from "../../../../helpers/getTitle";
import TooltipApp from "../../../../components/TooltipApp";
import {RiShareForwardFill} from "react-icons/ri";
import {PiLinkSimpleBold} from "react-icons/pi";
import {Link} from "react-router-dom";
import {ItemInfoGrid} from "../../../../components/common/ItemInfoGrid";

export const DetailViewForm = ({item, onCancel}) => {
    const t = useTranslate()
    const history = useHistory()
    const {isSm} = useContext(LayoutContext)
    const members = _.get(item, 'catholic_household_members', []);
    const householdFather = _.first(members.filter(e => e.id === _.get(item, 'household_father.id')))
    const householdMother = _.first(members.filter(e => e.id === _.get(item, 'household_mother.id')))
    const householdMotherMatrimony = _.find(_.get(householdMother, 'sacraments', []), {sacrament_type: 'matrimony'})
    const householdFatherMatrimony = _.find(_.get(householdFather, 'sacraments', []), {sacrament_type: 'matrimony'})
    const childrenMembers = members.filter(e => e?.relationship_type === 'CHILDREN');

    const HighLightHeader = ({title}) => (
        <div className="w-full flex flex-col gap-2 flex-center">
            <GiIronCross className="text-green-500" size={isSm ? 25 : 35}/>
            <HeaderWithIconLine
                center={true}
                lineColor="border-green-300"
                renderTitle={() => (
                    <span className="font-semibold text-lg text-green-300 tracking-widest uppercase leading-tight">
                      {t(title)}
                  </span>
                )}
                className="mb-3 w-full"
            />
        </div>
    )

    return (
        <div className="flex flex-col gap-3 md:gap-6">
            <div className="mt-3 flex flex-col items-center">
                <span className="text-center font-bold text-2xl text-color-000 leading-snug uppercase tracking-widest">
                    {t('catholic household')}
                </span>
                <Link to={getLinkToDetail(item)} className="font-bold text-xl text-primary-700 no-underline tracking-widest">
                    {item?.title}
                </Link>
            </div>
            <div className="flex flex-col">
                <HighLightHeader title="church marriage certificate"/>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-center gap-2">
                            <GroomIconOutlineSvg size={18} className="text-blue-500"/>
                            <span className="font-semibold text-blue-600 capitalize leading-snug tracking-wider">
                                {t('the groom side')}
                            </span>
                        </div>
                        {renderIfElse(
                            householdFather,
                            <ParentMemberItemInfo item={householdFather}/>,
                            renderEmptyHolderMember("no data is available now", "household father description")
                        )}
                    </div>
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-center gap-2">
                            <BrideIconOutlineSvg size={18} className="text-blue-500"/>
                            <span className="font-semibold text-blue-600 capitalize leading-snug tracking-wider">
                                {t('the bride side')}
                            </span>
                        </div>
                        {renderIfElse(
                            householdMother,
                            <ParentMemberItemInfo item={householdMother}/>,
                            renderEmptyHolderMember("no data is available now", "household mother description")
                        )}
                    </div>
                </div>
                {renderIf(
                    householdFatherMatrimony,
                    <div className="mt-5 mb-3 flex flex-col flex-center gap-2">
                        <div className="flex flex-col text-center leading-snug">
                            <div className="font-bold text-lg text-primary uppercase tracking-widest">
                                {t('the sacrament of matrimony was celebrated')}
                            </div>
                            <div className="space-x-1 tracking-wider">
                                {renderIf(
                                    !!householdFatherMatrimony?.eff_date,
                                    <React.Fragment>
                                        <span className="text-base text-color-300 italic lowercase">{t('date')}</span>
                                        <span className="font-medium text-base text-primary-700">
                                            {formatDate(householdFatherMatrimony?.eff_date, 'DD/MM/YYYY')}
                                        </span>
                                    </React.Fragment>
                                )}
                                {renderIf(
                                    !!householdFatherMatrimony?.parish_name,
                                    <React.Fragment>
                                        <span className="text-base text-color-300 italic lowercase">{t('in')}</span>
                                        <span className="font-medium text-base text-primary-700">
                                            {householdFatherMatrimony?.parish_name}
                                        </span>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                        <div style={{width: isSm ? '100%' : 'unset'}} className="grid grid-cols-2 gap-2">
                            <ItemInfoGrid showIcon={true} center={!isSm && true} label="presiding priest"
                                          value={householdFatherMatrimony?.officiant_name}
                                          className="text-sm leading-snug"/>
                            <ItemInfoGrid showIcon={true} center={!isSm && true} label="marriage book no"
                                          value={householdFatherMatrimony?.source_idcode}
                                          className="text-sm leading-snug"/>
                            <ItemInfoGrid showIcon={true} center={!isSm && true} label="marriage witnesses 1"
                                          value={householdFatherMatrimony?.participant_name}
                                          className="text-sm leading-snug"/>
                            <ItemInfoGrid showIcon={true} center={!isSm && true} label="marriage witnesses 2"
                                          value={householdMotherMatrimony?.participant_name}
                                          className="text-sm leading-snug"/>
                        </div>
                    </div>
                )}
            </div>
            {renderIf(
                childrenMembers.length > 0,
                <div className="flex flex-col">
                    <HighLightHeader title="the children in the family"/>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {renderIfElse(
                            childrenMembers.length > 0,
                            childrenMembers.map((ee, ii) => {
                                return (
                                    <div key={ii} className="py-2 flex flex-col gap-1 render-border-center rounded-lg relative">
                                        <ChildrenMemberItemInfo index={ii} item={ee}/>
                                    </div>
                                )
                            }),
                            <EmptyHolder/>
                        )}
                    </div>
                </div>
            )}
            <div className="flex items-center justify-between gap-3 mx-0 md:mx-4 mt-3 mb-4">
                <div className="flex items-center gap-x-2">
                        <span className="text-xs text-color-400 italic leading-snug">
                            {`${t('share')} : `}
                        </span>
                    <HeaderButton
                        onClick={() => {callNativeShare({ title: getTitle(item), url: getAbsoluteLinkToDetail(item) })}}
                        width={24}
                        height={24}
                        icon={ <RiShareForwardFill size={12}/> }
                    />
                    <HeaderButton
                        onClick={() => {
                            copyToClipboard(getAbsoluteLinkToDetail(item))
                            message.success(t('copied'))
                        }}
                        width={24}
                        height={24}
                        icon={
                            <TooltipApp title={t('copy link')} placement="right" classNames={{ root: "flex text-xs italic" }}>
                                <PiLinkSimpleBold size={12}/>
                            </TooltipApp>
                        }
                    />
                </div>
                <div className="flex-1" />
                <span onClick={onCancel} className="font-medium text-color-300 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </span>
            </div>
        </div>
    )
}

const CreateHouseholdInfoStep = ({onBack, onChange}) => {
    const t = useTranslate()
    const {values} = useFormikContext()
    return (
        <div className="flex flex-col gap-3">
            <Pure>
                <FieldsFactory
                    formSchema={[
                        catholicHouseholdFormSchema.title,
                        catholicHouseholdFormSchema.parish,
                        catholicHouseholdFormSchema.source_id__eff_date,
                        catholicHouseholdFormSchema.description,
                    ]}
                />
            </Pure>
        </div>
    )
}

const sacramentList = [
    {
        value: 'baptism',
        label: 'sacrament of baptism',
        formSchema: [
            catholicHouseholdFormSchema.baptism__date__church_sacrament,
            catholicHouseholdFormSchema.baptism__parish__source_id_sacrament,
            catholicHouseholdFormSchema.baptism__officiant__participant_sacrament,
        ],
        key: 'baptism_eff_date'
    },
    {
        value: 'first_communion',
        label: 'first communion',
        formSchema: [
            catholicHouseholdFormSchema.first_communion__date__church_sacrament,
            catholicHouseholdFormSchema.first_communion__parish__source_id_sacrament,
            catholicHouseholdFormSchema.first_communion__officiant__participant_sacrament,
        ],
        key: 'first_communion_eff_date'
    },
    {
        value: 'confirmation',
        label: 'sacrament of confirmation',
        formSchema: [
            catholicHouseholdFormSchema.confirmation__date__church_sacrament,
            catholicHouseholdFormSchema.confirmation__parish__source_id_sacrament,
            catholicHouseholdFormSchema.confirmation__officiant__participant_sacrament,
        ],
        key: 'confirmation_eff_date'
    },
    {
        value: 'matrimony',
        label: 'sacrament of matrimony',
        formSchema: [
            catholicHouseholdFormSchema.matrimony__date__church_sacrament,
            catholicHouseholdFormSchema.matrimony__parish__source_id_sacrament,
            catholicHouseholdFormSchema.matrimony__officiant__participant_sacrament,
        ],
        key: 'matrimony_eff_date'
    },
    {
        value: 'holy_orders',
        label: 'sacrament of holy orders',
        formSchema: [
            catholicHouseholdFormSchema.holy_orders__date__church_sacrament,
            catholicHouseholdFormSchema.holy_orders__officiant__parish_sacrament,
        ],
        key: 'holy_orders_eff_date'
    },
]

const CreateHouseholdMemberStep = () => {
    const t = useTranslate()

    return (
        <div className="flex flex-col gap-5 py-2">
            {/* Thông tin chủ hộ */}
            <div className="flex flex-col gap-3">
                <HeaderWithIconLine
                    icon={<GoDotFill size={11} className="text-color-300"/>}
                    lineColor="border-color-100"
                    title="head of household"
                    className="text-xs font-semibold text-color-400 uppercase tracking-wider"
                />
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            catholicHouseholdFormSchema.relationship_type,
                            catholicHouseholdFormSchema.patron_saint__feast_day,
                            catholicHouseholdFormSchema.full_name_only,
                            catholicHouseholdFormSchema.date__place__gender,
                            catholicHouseholdFormSchema.parent,
                        ]}
                    />
                </Pure>
            </div>

            {/* Bí tích */}
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    icon={<GoDotFill size={11} className="text-color-300"/>}
                    lineColor="border-color-100"
                    title="sacraments"
                    className="text-xs font-semibold text-color-400 uppercase tracking-wider"
                />
                {sacramentList.map((se, si) => (
                    <Toggle key={si} defaultValue={false}>
                        {(isToggle, toggle) => (
                            <div className="border border-color-100 rounded-xl overflow-hidden">
                                <div
                                    onClick={() => toggle(!isToggle)}
                                    className="flex items-center justify-between px-4 py-3 cursor-pointer hover:background-50 transition-colors select-none">
                                    <div className="flex items-center gap-2">
                                        <GoDotFill
                                            size={10}
                                            className={isToggle ? 'text-blue-400' : 'text-color-200'}
                                        />
                                        <span className={classNames(
                                            'font-semibold text-xs uppercase tracking-wider',
                                            isToggle ? 'text-blue-500' : 'text-color-400'
                                        )}>
                                            {t(se.label)}
                                        </span>
                                    </div>
                                    <BsChevronDown
                                        size={12}
                                        style={{
                                            transform: isToggle ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.2s ease',
                                        }}
                                        className="text-color-400"
                                    />
                                </div>
                                <div
                                    className="overflow-hidden"
                                    style={{maxHeight: isToggle ? 800 : 0, transition: 'max-height 0.25s ease'}}>
                                    <div className="px-4 pt-2 pb-4 border-t border-color-50">
                                        <Pure>
                                            <FieldsFactory formSchema={se.formSchema}/>
                                        </Pure>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Toggle>
                ))}
            </div>
        </div>
    )
}

const CreateHouseholdContactStep = ({onBack, onChange}) => {
    const t = useTranslate()
    const {values} = useFormikContext()
    return (
        <div className="flex flex-col gap-3">
            <Pure>
                <FieldsFactory
                    formSchema={[
                        catholicHouseholdFormSchema.contact_name,
                        catholicHouseholdFormSchema.contact_phone,
                        catholicHouseholdFormSchema.contact_address,
                    ]}
                />
            </Pure>
        </div>
    )
}

const buildSteps = (t) => [
    {
        path: '/info',
        exact: true,
        title: 'information catholic household',
        description: 'book name, parish, date join parish',
        fields: ['title', 'parish_name'],
        component: CreateHouseholdInfoStep,
        validate: (values) => {
            let errors = {}
            _.forEach(['title'], (name) => {
                const value = _.get(values, name)
                if (_.isEmpty(value ?? undefined)) {
                    errors[name] = t('required field')
                }
            })

            if (!_.get(values, 'parish_name')) {
                errors['parish_name'] = t('required field')
            }

            return errors
        }
    },
    {
        path: '/member',
        exact: true,
        title: 'head of household',
        description: 'head of household description',
        fields: ['member_user'],
        component: CreateHouseholdMemberStep,
        validate: (values) => {
            let errors = {}
            _.forEach(['member_user'], (name) => {
                const value = _.get(values, name)
                if (_.isEmpty(value ?? undefined)) {
                    errors[name] = t('required field')
                }
            })
            return errors
        }
    },
    {
        path: '/contact',
        exact: true,
        title: 'contact',
        description: 'contact household description',
        component: CreateHouseholdContactStep,
        validate: () => {
            return {}
        }
    }
]

export const CreateCatholicHouseholdStepForm = ({
                                                    owner_type, owner_id,
                                                    onCancel = NullAsDefault,
                                                    onSubmit = NullAsDefault,
                                                }) => {
    const t = useTranslate()
    const steps = buildSteps(t)

    const validate = (values) => {
        let errors = {}
        _.forEach(['title', 'member_user'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })

        if (!!!_.get(values, 'parish_name')) {
            errors['parish'] = t('required field')
        }

        return errors
    }

    const initialValues = {
        title: undefined,
        relationship_type: 'FATHER',
        gender: 1,
        owner_type, owner_id
    }

    return (
        <StepsForm
            className="custom-steps-create"
            faded={false}
            stepHeader={true}
            routes={steps}
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            actionBarCenter={true}
            onSubmit={({
               eff_date, parish,
               birth_date,
               baptism_eff_date, first_communion_eff_date, confirmation_eff_date, matrimony_eff_date, holy_orders_eff_date,
               patron_saint, member_user, birth_province,
               baptism_church, baptism_parish, baptism_diocese, baptism_officiant_user, baptism_participant_user,
               first_communion_church, first_communion_parish, first_communion_diocese, first_communion_officiant_user,
               confirmation_church, confirmation_parish, confirmation_diocese, confirmation_officiant_user, confirmation_participant_user,
               matrimony_church, matrimony_parish, matrimony_diocese, matrimony_officiant_user, matrimony_participant_user,
               holy_orders_church, holy_orders_parish, holy_orders_officiant_user, holy_orders_participant_user,
               ...values
            }) => {
                onSubmit(
                    _.omitBy({
                        ...values,
                        eff_date: getDateString(eff_date),
                        birth_date: getDateString(birth_date),
                        baptism_eff_date: getDateString(baptism_eff_date),
                        first_communion_eff_date: getDateString(first_communion_eff_date),
                        confirmation_eff_date: getDateString(confirmation_eff_date),
                        matrimony_eff_date: getDateString(matrimony_eff_date),
                        holy_orders_eff_date: getDateString(holy_orders_eff_date),
                    }, _.isUndefined)
                )
            }}
        />
    )
}


export const CreateMyCatholicHouseholdStepForm = ({
                                                      onCancel = NullAsDefault,
                                                      onSubmit = NullAsDefault,
                                                  }) => {
    const t = useTranslate()
    const steps = buildSteps(t)

    const validate = (values) => {
        let errors = {}
        _.forEach(['title'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })

        if (!!!_.get(values, 'parish_name')) {
            errors['parish'] = t('required field')
        }

        return errors
    }

    const initialValues = {
        title: undefined,
        relationship_type: 'FATHER',
        gender: 1,
    }

    return (
        <StepsForm
            className="custom-steps-create"
            faded={false}
            stepHeader={true}
            routes={steps}
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            actionBarCenter={true}
            onSubmit={({
                eff_date, parish,
                birth_date,
                baptism_eff_date, first_communion_eff_date, confirmation_eff_date, matrimony_eff_date, holy_orders_eff_date,
                patron_saint, member_user, birth_province,
                baptism_church, baptism_parish, baptism_diocese, baptism_officiant_user, baptism_participant_user,
                first_communion_church, first_communion_parish, first_communion_diocese, first_communion_officiant_user,
                confirmation_church, confirmation_parish, confirmation_diocese, confirmation_officiant_user, confirmation_participant_user,
                matrimony_church, matrimony_parish, matrimony_diocese, matrimony_officiant_user, matrimony_participant_user,
                holy_orders_church, holy_orders_parish, holy_orders_officiant_user, holy_orders_participant_user,
                ...values
            }) => {
                onSubmit(
                    _.omitBy({
                        ...values,
                        eff_date: getDateString(eff_date),
                        birth_date: getDateString(birth_date),
                        baptism_eff_date: getDateString(baptism_eff_date),
                        first_communion_eff_date: getDateString(first_communion_eff_date),
                        confirmation_eff_date: getDateString(confirmation_eff_date),
                        matrimony_eff_date: getDateString(matrimony_eff_date),
                        holy_orders_eff_date: getDateString(holy_orders_eff_date),
                    }, _.isUndefined)
                )
            }}
        />
    )
}


export const EditCatholicHouseholdForm = ({
                                              initialValues,
                                              handleOpenMemberManagement = NullAsDefault,
                                              onCancel = NullAsDefault,
                                              onSubmit = NullAsDefault,
                                          }) => {
    const t = useTranslate()
    const {} = initialValues;
    const _initialValues = {
        ...initialValues,
        parish: initialValues?.parish,
        parish_name: initialValues?.parish?.name || initialValues?.parish_name,
        parish_id: initialValues?.parish?.id,
        household_father_id: initialValues?.household_father?.id,
        household_mother_id: initialValues?.household_mother?.id,
        household_head_id: initialValues?.household_head?.id,
        eff_date: !!initialValues?.eff_date ? parseDayjs(initialValues?.eff_date) : undefined,
    }

    const validate = (values) => {
        let errors = {}
        _.forEach(['title', 'eff_date'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={({eff_date, ...values}, ...props) => {
                const changes = shallowDiff(values, initialValues)
                const {household_head_id, household_father_id, household_mother_id} = changes;

                onSubmit(
                    _.omitBy({
                        ...changes,
                        ...(!!eff_date ? {eff_date: getDateString(eff_date)} : {}),
                        ...(!!household_head_id ? {household_head_id: household_head_id?.id} : {}),
                        ...(!!household_father_id ? {household_father_id: household_father_id?.id} : {}),
                        ...(!!household_mother_id ? {household_mother_id: household_mother_id?.id} : {}),
                    }, _.isUndefined)
                )
            }}>
            <div className="flex flex-col gap-4 px-4 py-3">
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        icon={<GoDotFill size={16} className="text-green-300"/>}
                        lineColor="border-green-300"
                        title="information catholic household"
                        className="text-lg text-green-600"
                    />
                    <FieldsFactory
                        formSchema={[
                            catholicHouseholdFormSchema.title,
                            catholicHouseholdFormSchema.parish,
                            catholicHouseholdFormSchema.source_id__eff_date,
                            catholicHouseholdFormSchema.description,
                        ]}
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-1">
                        <HeaderWithIconLine
                            icon={<GoDotFill size={16} className="text-green-300"/>}
                            lineColor="border-green-300"
                            title="church marriage certificate"
                            className="text-lg text-green-600"
                        />
                        <span className="text-xs text-color-500 italic">
                            <span className="font-semibold text-color-300">{`* ${t('note')} : `}</span>
                            <span>{t('church marriage certificate description')}</span>
                        </span>
                    </div>
                    <FormikConsumer>
                        {({values, errors, handleChange}) => {
                            const members = _.get(initialValues, 'catholic_household_members', []);
                            const householdFather = _.first(members.filter(e => e.id === _.get(values, 'household_father_id.id', _.get(values, 'household_father_id'))))
                            const householdMother = _.first(members.filter(e => e.id === _.get(values, 'household_mother_id.id', _.get(values, 'household_mother_id'))))
                            const householdFatherMatrimony = _.find(_.get(householdFather, 'sacraments', []), {sacrament_type: 'matrimony'})
                            const householdMotherMatrimony = _.find(_.get(householdMother, 'sacraments', []), {sacrament_type: 'matrimony'})

                            return (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div className="flex flex-col gap-1">
                                        <FieldsFactory
                                            formSchema={[
                                                catholicHouseholdFormSchema.father_of_household,
                                            ]}
                                        />
                                        {renderIfElse(
                                            householdFatherMatrimony,
                                            <SacramentItem item={householdFatherMatrimony}/>,
                                            <EmptyHolderWithAction
                                                title="no data is available now"
                                                description="household father matrimony description"
                                                icon={<FiEdit3 size={10} className="mr-2"/>}
                                                action={() => {
                                                    handleOpenMemberManagement()
                                                }}
                                                labelAction="click here to edit"
                                                className="mt-6"
                                            />
                                        )}
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <FieldsFactory
                                            formSchema={[
                                                catholicHouseholdFormSchema.mother_of_household,
                                            ]}
                                        />
                                        {renderIfElse(
                                            householdMotherMatrimony,
                                            <SacramentItem item={householdMotherMatrimony}/>,
                                            <EmptyHolderWithAction
                                                title="no data is available now"
                                                description="household father matrimony description"
                                                icon={<FiEdit3 size={10} className="mr-2"/>}
                                                action={() => {
                                                    handleOpenMemberManagement()
                                                }}
                                                labelAction="click here to edit"
                                                className="mt-6"
                                            />
                                        )}
                                    </div>
                                </div>
                            )
                        }}
                    </FormikConsumer>
                </div>
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        icon={<GoDotFill size={16} className="text-green-300"/>}
                        lineColor="border-green-300"
                        title="contact information"
                        className="mt-3 text-lg text-green-600"
                    />
                    <FieldsFactory
                        formSchema={[
                            catholicHouseholdFormSchema.head_of_household,
                            catholicHouseholdFormSchema.contact_name,
                            catholicHouseholdFormSchema.contact_phone,
                            catholicHouseholdFormSchema.contact_address,
                        ]}
                    />
                </div>

                <FormikConsumer>
                    {({isValid, isSubmitting, handleSubmit}) => (
                        <div className="border-t border-color-50 pt-3 pb-1">
                            <Button
                                type="primary"
                                onClick={handleSubmit}
                                disabled={!isValid}
                                loading={isSubmitting}
                                className="w-full button-rounded-lg no-border font-bold"
                                style={{height: 48, fontSize: 15}}>
                                {t('save')}
                            </Button>
                        </div>
                    )}
                </FormikConsumer>
            </div>
        </Formik>
    )
}

